@let isInUse = writingHelperFeature.selectors.isInUse.asSignal();

<atn-platform-writing-helper-handle
  #handle="cdkOverlayOrigin"
  cdkOverlayOrigin
  (click)="
    writingHelperFeature.actions.initiate
      .from('PlatformWritingHelper.Handle.Clicked')
      .dispatch()
  "
/>

@if (isInUse) {
  <atn-ds-attached-overlay
    [origin]="handle"
    [connectedPositions]="[
      {
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom',
        offsetY: -15,
      },
    ]"
  >
    <atn-platform-writing-helper-pop-up />
  </atn-ds-attached-overlay>
}
